import React from 'react'
import { Row, Col } from 'antd'

// 財務章(發票章)財務資訊唯讀顯示：把序列化的 description 解析成結構化欄位，
// 顯示格式與「填寫發票章」申請頁一致(他方名稱/他方單號/總金額類型，有金額才再顯示金額等)。

// 欄位顯示順序(對齊 StampApplyAddAndView 的 formatFinanceDescription)
const FIELD_ORDER = [
  '公司別',
  '他方名稱',
  '他方單號',
  '總金額類型',
  '金額',
  '幣別',
  '應收/付款',
  '收/付款方式',
  'Payment Term',
  '稅金',
]

// 判斷一段 description 是否為財務資訊(發票章送出的格式必含「總金額類型：」)
export const isFinanceDescription = (description) =>
  typeof description === 'string' && description.includes('總金額類型：')

const parseFinance = (description) => {
  const map = {}
  ;(description || '').split('\n').forEach((line) => {
    const i = line.indexOf('：')
    if (i > -1) {
      map[line.slice(0, i).trim()] = line.slice(i + 1).trim()
    }
  })
  return map
}

const FinanceInfoView = ({ description }) => {
  const map = parseFinance(description)
  const rows = FIELD_ORDER.filter((label) => map[label] !== undefined && map[label] !== '')
  return (
    <div>
      {rows.map((label) => (
        <Row key={label} gutter={[8, 4]} style={{ marginBottom: '6px' }}>
          <Col style={{ fontWeight: 600, color: '#595959', minWidth: '110px' }}>{label}</Col>
          <Col style={{ color: 'black', wordBreak: 'break-all' }}>{map[label]}</Col>
        </Row>
      ))}
    </div>
  )
}

export default FinanceInfoView
